import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isNew: true,
  isDataChanged: false,
  reloadPage: false,
  data: {
    fromYear: undefined,
    toYear: undefined,
    fromHeight: 100,
    toHeight: 230,
    fitnessCode: "",
    beliefTypeCodes: [],
    clothingTypeCodes: [],
    politicalOrientationCodes: [],
    religionDescription: "",
    livingCityPriorityOneId: 0,
    livingCityPriorityTwoId: "",
    livingCityPriorityThreeId: "",
    residenceAbroadTypeCode: undefined,
    spouseFamilyInOtherCityAllowed: false,
    spouseEconomicMatterCodes: [],
    spouseWorkingMatterCodes: [],
    spouseMaritalStatusAcceptanceCode: undefined,
    spouseMilitaryAllowed: false,
    spouseSpiritualAllowed: false,
    spouseEthnicityMatter: false,
    spouseEthnicityCodes: [],
    spouseEthnicityCode: undefined,
    spousePersonalityCode: "27003",
    educationDescription: "",
    spouseSingle: false,
    spouseUnsuccessfulContract: false,
    spouseDivorced: false,
    spouseMartyr: false,
    spouseDeceased: false,
    haveChildrenAllowed: false,
    childGenderMatter: false,
    childrenCountMatter: false,
    childrenAgeMatter: false,
    marriageDescription: "",
    spouseNotSmoker: false,
    hookahAllowed: false,
    spouseMustBeAthlete: false,
    spouseMustBeArtist: false,
    otherDemands: [],
    isContactMe: true,
    trustedFirstName: "",
    trustedLastName: "",
    trustedLandNumber: "",
    trustedRelation: "",
    trustedRelation1: "",
    trustedMobileNumber: "",
  },
};

export const DemandsInformationSlice = createSlice({
  name: "demandsInformation",
  initialState,
  reducers: {
    updateDemandsInformationData: (state, { payload: { key, value, required } }) => {
      state.isDataChanged = true;
      state.data[key] = value;
      if (value !== undefined && value.length === 0) {
        if (required) {
          state.data[key] = value;
        } else {
          delete state.data[key];
        }
      } else {
        state.data[key] = value;
      }
    },
    setIsDataChangedForDemands: (state, { payload }) => {
      state.isDataChanged = payload;
    },
    setIsNewForDemandsInformation: (state, { payload }) => {
      state.isNew = payload;
    },
    setDemandsInformationData: (state, { payload }) => {
      state.isDataChanged = false;
      state.isNew = false;
      state.data = payload;
    },
    updateArrayFieldDemandsInformationData: (state, { payload: { key, value, code, reset } }) => {
      state.isDataChanged = true;
      let codes = [];
      if (state.data[key]) {
        codes = [...state.data[key]];
      }
      if (!reset)
        if (value) {
          codes.push(code);
        } else {
          codes = codes.filter((item) => item !== code);
        }
      state.data[key] = reset ? [] : codes;
    },
    addNewOtherDemand: (state, { payload }) => {
      state.isDataChanged = true;
      state.data.otherDemands.push("");
    },
    removeFromOtherDemand: (state, { payload: index }) => {
      state.isDataChanged = true;
      state.data.otherDemands.splice(index, 1);
    },
    updateOtherDemand: (state, { payload: { index, value } }) => {
      state.isDataChanged = true;
      state.data.otherDemands[index] = value;
    },
    clearDemandsInformationData: () => initialState,
    setReloadDemandsInformationData: (state, { payload }) => {
      state.reloadPage = payload;
    },
  },
});
export const {
  updateDemandsInformationData,
  setIsNewForDemandsInformation,
  setDemandsInformationData,
  updateArrayFieldDemandsInformationData,
  setIsDataChangedForDemands,
  addNewOtherDemand,
  removeFromOtherDemand,
  updateOtherDemand,
  clearDemandsInformationData,
  setReloadDemandsInformationData,
} = DemandsInformationSlice.actions;
export const DemandsInformationReducer = DemandsInformationSlice.reducer;
